import * as React from 'react';
import { ChargeTypes } from '@nkr/enums/index';
import DisputeComments from './dispute-comments';
import { Well } from 'react-bootstrap';

interface IProps {
    edit: boolean,
    valid: boolean,
    comments: string,
    chargeType: ChargeTypes,
    allowChange: boolean,
    backgroundColor: string,
    onEditComments: (chargeType: ChargeTypes) => void,
    onSubmitComments: (comments: string, chargeType: ChargeTypes) => void,
    onCancelComments: (chargeType: ChargeTypes) => void
}

class DisputeCommentsTableRow extends React.Component<IProps, {}> {
    handleSubmitComments = (comments: string) => {
        this.props.onSubmitComments(comments, this.props.chargeType);
    }

    handleCancelComments = () => {
        this.props.onCancelComments(this.props.chargeType);
    }

    handleEditComments = () => {
        this.props.onEditComments(this.props.chargeType);
    }

    render = () => {
        const comments = this.props.comments.length > 0 ? this.props.comments.split('\n') : [];

        return (
            <tr style={{ backgroundColor: this.props.backgroundColor }}>
                <td colSpan={5} style={{ borderTop: '0 none' }}>
                    <Well style={{ display: 'flex', marginBottom: 10, padding: 10, border: this.props.valid ? '' : '2px solid red' }}>
                        <div style={{ flexBasis: '15%' }}>Reason for dispute:</div>
                        {this.props.allowChange ?
                            this.props.edit ?
                                <DisputeComments
                                    comments={this.props.comments}
                                    onSubmit={this.handleSubmitComments}
                                    onCancel={this.handleCancelComments}
                                />
                                :
                                <div className='editable-comments' style={{ flexBasis: '85%', textAlign: 'left' }} onClick={this.handleEditComments}>
                                    {comments.length > 0 ?
                                        comments.map((comment, index) =>
                                            <div key={index}>{comment}</div>
                                        )
                                        :
                                        <>[click here to enter a reason]</>
                                    }
                                </div>
                            :
                            <div style={{ flexBasis: '85%', textAlign: 'left' }}>
                                {comments.map((comment, index) =>
                                    <div key={index}>{comment}</div>
                                )}
                            </div>
                        }
                    </Well>
                </td>
            </tr>
        );
    }
}

export default DisputeCommentsTableRow